export default __webpack_public_path__ + "static/media/CareerDevelopment.1371fac9.svg";